<template>
  <div
    :class="seriesPackListItemClasses"
    :id="seriesPackListItemId"
    :style="seriesPackListItemStyles"
  >
    <div class="left">
      <div class="pack-index">第{{ pack.packIndex + 1 }}集</div>
    </div>
    <div class="right">
      <div class="header">
        <div class="title">{{ pack.title }}</div>
        <div class="meta">
          (
          <div class="node-count">{{ pack.nodeCount }} 节</div>
          <div class="duration">{{ pack.duration }}</div>
          )
        </div>
      </div>
      <SeriesPackNodeList :nodes="pack.nodes" v-if="true" :current="current" />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import SeriesPackNodeList from '@/series/components/series-pack-node-list';

export default defineComponent({
  name: 'SeriesPackListItem',

  /**
   * 属性
   */
  props: {
    pack: Object,
    current: Object,
  },

  /**
   * 数据
   */
  data() {
    return {};
  },

  /**
   * 计算属性
   */
  computed: {
    seriesPackListItemClasses() {
      const isActive =
        this.current && this.current.packId
          ? this.current.packId === this.pack.id
          : null;

      return ['series-pack-list-item', { active: isActive }];
    },

    seriesPackListItemId() {
      return `pack-${this.pack.id}`;
    },

    seriesPackListItemStyles() {
      let dotColor = 'var(--line-color)';

      if (parseInt(`${this.pack.progress}`, 10) === 100) {
        dotColor = 'var(--series-color)';
      }

      return {
        '--dot-color': dotColor,
      };
    },
  },

  /**
   * 已创建
   */
  created() {
    //
  },

  /**
   * 已挂载
   */
  mounted() {
    //
  },

  /**
   * 组件方法
   */
  methods: {},

  /**
   * 使用组件
   */
  components: {
    SeriesPackNodeList,
  },
});
</script>

<style scoped>
@import './styles/series-pack-list-item.css';
</style>
